<template>
  <div class="pfcard" :class="{'active':active}">
    <div class="pfcard__icon" v-html="card.icon"></div>
    <div class="pfcard__body">
      <div class="pfcard__abovetitle">{{card.abovetitle}}</div>
      <div class="pfcard__title" :class="{'pfcard__title_inc':inctitle}">{{card.title}}</div>
    </div>  
  </div>
</template>

<script>
  export default {
    props: {
      card: {type: Object, require: true},
      active: {default: 1},
      inctitle: {type: Boolean, default: false}
    }
  }
</script>

<style lang="sass" scoped>
.pfcard
  padding: 16px
  background: colors.$mainbg
  transition: opacity .4s ease-out
  opacity: .3
  border: 1px solid #ECEDEE
  border-radius: 8px
  box-shadow: 0px 20px 40px var(--shadows,rgba(52, 53, 64, 0.1))
  display: flex    
  color: colors.$bluefont5b
  @include for-mob
    padding: 14px 16px
  &.active 
    opacity: 1
  &__icon
    margin-right: 16px
    svg
      display: block
      width: 64px
      height: 64px
  &__abovetitle
    font-size: 14px
    margin-top: 1px
    line-height: 1.12
    margin-bottom: 9px
    letter-spacing: globalvars.$onespacing
  &__title
    font-weight: 500
    font-size: 18px
    line-height: 1.12
    color: colors.$bluefont2
    &_inc
      font-size: 20px
      line-height: 32px
</style>